





























































































import { Component, Vue } from "vue-property-decorator";
import { translate } from "@/utils";
import { PointMeterModule } from "@/store/pointmeter.module";
import { PointMeter } from "~/pointmeter.type";
import ExpansionPanel from "../ui/ExpansionPanel.vue";

@Component({
  components: { ExpansionPanel },
})
export default class PointMeterView extends Vue {
  get aPointMeter(): PointMeter {
    return translate(PointMeterModule.aPointMeter);
  }

  async mounted() {
    PointMeterModule.loadPointMeter(parseInt(this.$route.params.pointId));
  }
}
